import React from 'react';
import './ParallaxHero.css';
import { useParallax } from 'react-scroll-parallax';
import DynamicText from './DynamicText';

const ParallaxHero = ({ title, subtitle, description, buttons, dynamicWords }) => {
    // Use the useParallax hook for scaling effects
    const backgroundParallax = useParallax({
        scale: [1.2, 1, "easeOutQuad"],
        opacity: [0.8, 1, "easeOutQuad"],
        shouldAlwaysCompleteAnimation: true,
        expanded: false
    });

    const titleParallax = useParallax({
        translateY: [20, 0, "easeOutQuad"],
        opacity: [0.7, 1, "easeOutQuad"],
        shouldAlwaysCompleteAnimation: true,
        expanded: false
    });

    const subtitleParallax = useParallax({
        translateY: [15, 0, "easeOutQuad"],
        opacity: [0.7, 1, "easeOutQuad"],
        shouldAlwaysCompleteAnimation: true,
        expanded: false,
        startScroll: 30
    });

    const descriptionParallax = useParallax({
        translateY: [10, 0, "easeOutQuad"],
        opacity: [0.7, 1, "easeOutQuad"],
        shouldAlwaysCompleteAnimation: true,
        expanded: false,
        startScroll: 60
    });

    const buttonsParallax = useParallax({
        translateY: [5, 0, "easeOutQuad"],
        opacity: [0.7, 1, "easeOutQuad"],
        shouldAlwaysCompleteAnimation: true,
        expanded: false,
        startScroll: 90
    });

    return (
        <div className="parallax-container">
            {/* Hero Section with Parallax Scaling Effect */}
            <section className="hero-section">
                <div className="hero-split-layout">
                    <div className="hero-text-content">
                        <div ref={titleParallax.ref} className="title-wrapper">
                            <h1 id="hero-title" className="hero-title">
                                {dynamicWords && dynamicWords.length > 0 ? (
                                    <DynamicText 
                                        staticText={title}
                                        dynamicWords={dynamicWords}
                                        typingSpeed={150}
                                        deletingSpeed={100}
                                        pauseDuration={2000}
                                    />
                                ) : (
                                    title
                                )}
                            </h1>
                        </div>
                        <div ref={subtitleParallax.ref} className="subtitle-wrapper">
                            <p id="hero-subtitle" className="hero-subtitle">
                                {subtitle}
                            </p>
                        </div>
                        <div ref={descriptionParallax.ref} className="description-wrapper">
                            <p className="hero-description">
                                {description}
                            </p>
                        </div>
                        <div ref={buttonsParallax.ref} className="buttons-wrapper">
                            <div className="hero-buttons">
                                {buttons && buttons.map((button, index) => (
                                    <a 
                                        key={index} 
                                        href={button.url} 
                                        className={button.primary ? 'primary-button' : 'secondary-button'}
                                    >
                                        {button.text}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="hero-image-content">
                        <div ref={backgroundParallax.ref} className="hero-image-wrapper">
                            <img 
                                src={process.env.PUBLIC_URL + "/images/ai-visualization.jpg"}
                                alt="AI Visualization"
                                className="hero-side-image"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ParallaxHero;
